import { PositionDrawingFilterState } from '../screens/admin/position-drawing/components/positionDrawingFilters'
import { PositionDrawingTableFilters } from '../screens/admin/position-drawing/positionDrawingTable'

export const defaultPositionDrawingFilterState: PositionDrawingFilterState = {
  searchInput: '',
  productCategoryIds: [],
}

export const getPositionDrawingQueryCategoryIds = (productCategoryIds: EntityId[]): EntityId[] | undefined =>
  productCategoryIds.length > 0 ? productCategoryIds : undefined

export const toPositionDrawingTableFilters = (
  debouncedSearch: string,
  productCategoryIds: EntityId[],
): PositionDrawingTableFilters => ({
  searchInput: debouncedSearch,
  productCategoryIds: getPositionDrawingQueryCategoryIds(productCategoryIds),
})
